/** Finished sidebar presentation. Display estimates never authorize spending or replace the run owner's fresh quote. */
import * as z from 'zod';
export const studyBuilderCreditBarSchema = z.strictObject({
    allowance: z.number().int().nonnegative(),
    maximum: z.number().int().nonnegative(),
    available: z.number().int().nonnegative(),
    estimate: z.number().int().nonnegative().nullable(),
    description: z.string().min(1),
    availableLabel: z.string().min(1),
    estimateLabel: z.string().min(1).nullable(),
    tone: z.enum(['subdued', 'critical']),
});
export const studyBuilderSidebarSchema = z.strictObject({
    creditEstimate: z.number().int().nonnegative().nullable(),
    credits: z.discriminatedUnion('state', [
        z.strictObject({ state: z.literal('ready'), line: z.null(), bar: studyBuilderCreditBarSchema }),
        z.strictObject({ state: z.literal('no-plan'), line: z.string().min(1), bar: z.null() }),
        z.strictObject({ state: z.literal('unavailable'), line: z.string().min(1), bar: z.null() }),
    ]),
    timing: z.strictObject({
        state: z.enum(['ready', 'insufficient-history', 'unavailable']),
        line: z.string().min(1),
    }),
});
export const SHOPIFY_STUDY_BUILDER_SIDEBAR_OPERATION = {
    id: 'study-builder.sidebar',
    method: 'POST',
    path: '/api/study-builder/sidebar',
    requestSchema: z.strictObject({ creditEstimate: z.number().int().nonnegative().nullable() }),
    responseSchema: studyBuilderSidebarSchema,
    auth: { merchant: true, operator: true, requiresOfflineToken: false, merchantOnlyGates: [] },
    effects: [{ kind: 'external-fetch', description: 'Signed Web-owned account balance and retained run timing read' }],
    risk: { cost: 'free', destructive: false, dryRunCapable: true },
    idempotent: true,
};
//# sourceMappingURL=shopify-study-builder-sidebar.js.map